@if (dataSource) {
  @let isLoading = dataSource.isLoading$ | async;
  @if (isLoading) {
    <div class="loading">
      <shared-local-dot-loader />
    </div>
  } @else if (dataSource.isEmpty$ | async) {
    <div class="loading-empty">
      <p class="m-t-24">No data available.</p>
    </div>
  }
}
